// The automatic morning briefing (AI chat): at most once per SHIP day, and only on an empty chat. Checked when the chat
// opens AND again at the moment it would be sent - a message typed or sent in between always wins (it must never go out
// right after the user's own message).

// empty = at most the greeting (one AI message), no user message; anything typed in the box counts too
export function chatIsEmpty(messages, input) {
  if (String(input || '').trim()) return false
  const m = messages || []
  return m.length <= 1 && m.every(x => x && x.role !== 'user')
}

export function shouldAutoBrief({ lastDay, shipDay, messages, input, sending, handedOff }) {
  if (!shipDay || lastDay === shipDay) return false   // once per ship day
  if (sending || handedOff) return false             // a request is running / the phone handed over a photo or the mic
  return chatIsEmpty(messages, input)
}
